
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "Skip2788952351",
      {"classes":{"root":"Skip2788952351__root","button":"Skip2788952351__button","iconWrapper":"Skip2788952351__iconWrapper","backSkip":"Skip2788952351__backSkip","disabled":"Skip2788952351__disabled"},"vars":{},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  